module.exports = __webpack_public_path__ + "img/gc_country_flag_nz.a56d7257.svg";